import { Box, Card, Checkbox, Modal } from '@mui/material';
import { makeStyles } from "@mui/styles";
import React from 'react'
import cssClasses from "./AdjustToken.module.css";
import { useEffect } from 'react';
import Close from '../../Components/Icons/Close';
import Button from '../../Subcomponents/Button';
import LeadStatusChip from '../../Subcomponents/LeadStatusChip';
import Dot from '../../Components/Icons/Dot';
import { getTokensByLeadId } from '../../Services/AllAllotments';
import { useState } from 'react';
import { errorTost, successTost } from '../../Services/Toast';
import { supabase } from '../../supabaseClient';
import { dismissLoader, presentLoader } from '../../Services/loader';
import ConfirmationAlert from '../../Subcomponents/ConfirmationAlert';


const useStyles = makeStyles((theme) => ({
    closeIcon: {
        cursor: "pointer",
        position: "absolute",
        right: "2rem",
    },
}));

export default function AdjustToken({ open, handleClose, allotment }) {
    const classes = useStyles();
    const [tokens, setTokens] = useState([])
    const [flag, setFlag] = useState(null)
    const [openAlert, setOpenAlert] = useState(false)
    const [selectedTokens, setSelectedTokens] = useState([])

    useEffect(() => {
        console.log(allotment)
        presentLoader()
        getTokensByLeadId(allotment.leadid, allotment.paymentid ? allotment.paymentid : '').then(async (resp) => {
            if (!resp.error && resp.data.length > 0) {
                let arr = []
                // for (const ele of resp.data) {
                //     let linkedToken = await supabase.from('EventTokenLeadRelations').select('*,eventId(*),eventTokenId(*,tokenId(*))')
                //         .eq('linkedTokenId', ele.paymentId)
                //         // ! vedashree changes ==> showing adjusted GT token in preselect allotment again for adjustment here
                //         // ! changed for PBC event, 17 Aug,2023
                //         .in('status', ['active', 'alloted'])
                //     if (linkedToken.data.length > 0) {
                //         if (ele.eventTokenId.tokenId.isPreselect) {
                //             //  ! if preselect, do not show GT to adjust
                //             // linkedToken.data[0].linkedTokenId = null
                //             // arr.push(linkedToken.data[0])
                //         } else {
                //             // ele.linkedTokenId = linkedToken.data[0]
                //             if (ele.status === 'adjusted' && linkedToken.data[0].status === 'active') {
                //                 linkedToken.data[0].linkedTokenId = null
                //                 arr.push(linkedToken.data[0])
                //             } else {
                //                 ele.linkedTokenId = linkedToken.data[0]
                //             }
                //         }
                //     }
                // }
                // ! vedashree changes => below code from live
                for (const ele of resp.data) {
                    let linkedToken = await supabase.from('EventTokenLeadRelations').select('*,eventId(*),eventTokenId(*,tokenId(*))').eq('linkedTokenId', ele.paymentId)
                    if (linkedToken.data.length > 0) {
                        if (ele.eventTokenId.tokenId.isPreselect) {
                            //  ! if preselect, do not show GT to adjust
                            // linkedToken.data[0].linkedTokenId = null
                            // arr.push(linkedToken.data[0])
                        } else {
                            // ele.linkedTokenId = linkedToken.data[0]
                            if (ele.status === 'adjusted' && linkedToken.data[0].status === 'active') {
                                linkedToken.data[0].linkedTokenId = null
                                arr.push(linkedToken.data[0])
                            } else {
                                ele.linkedTokenId = linkedToken.data[0]
                            }
                        }
                    }
                }
                resp.data = [...resp.data, ...arr]
                const filterByStatus = resp.data.filter((e) => e.status === "active")
                console.log("filterByStatus", filterByStatus)
                setTokens(filterByStatus.filter((e) => { return !e.eventTokenId.tokenId.isPreselect }))
                dismissLoader()
            } else {
                dismissLoader()
            }
            setFlag(true)
        }).catch((err) => {
            console.log(err)
        })
    }, [])

    function add(accumulator, a) {
        return accumulator + a;
    }

    useEffect(() => {
        console.log(tokens)
    }, [tokens])

    function numberWithCommas(x) {
        return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
    }

    function closeModal() {
        for (const ele of selectedTokens) {
            allotment.bookingamt.ocr = allotment.bookingamt.ocr + ele.myocr
            allotment.bookingamt.gst = allotment.bookingamt.gst + ele.mygst
            allotment.bookingamt.sdr = allotment.bookingamt.sdr + ele.mysdr
            allotment.unitcost.ocr = allotment.unitcost.ocr + ele.myocr1
            allotment.unitcost.gst = allotment.unitcost.gst + ele.mygst1
            allotment.unitcost.sdr = allotment.unitcost.sdr + ele.mysdr1
        }
        handleClose();
    }

    async function submit() {
      if (selectedTokens.length > 0) {
        let currentAmount = selectedTokens.reduce(
          (partialSum, a) => partialSum + a.paidAmount,
          0
        );
        let amountToBePaid = allotment.unitcost.total - allotment.paidamount;
        if (
          allotment?.pricingtype === "preselect" &&
          allotment?.preselectconfirmation !== "confirmed"
        ) {
          amountToBePaid =
            allotment.preselectamount - allotment.preselectpaidamount;
          
        }
        if (currentAmount > amountToBePaid) {
            errorTost(
              "Amount of Selected Tokens is greater than amount to be paid"
            );
          } else {
            setOpenAlert(true);
          }
      } else {
        errorTost("Please select tokens to adjust");
      }
    }

    async function ModalResp(e) {
        if (e === "confirmed") {
            presentLoader()
            
            let tokenpaidamount = 0
            for (const token of selectedTokens) {
                allotment.bookingamt.ocr = allotment.bookingamt.ocr + token.myocr
                allotment.bookingamt.gst = allotment.bookingamt.gst + token.mygst
                allotment.bookingamt.sdr = allotment.bookingamt.sdr + token.mysdr
                allotment.unitcost.ocr = allotment.unitcost.ocr + token.myocr1
                allotment.unitcost.gst = allotment.unitcost.gst + token.mygst1
                allotment.unitcost.sdr = allotment.unitcost.sdr + token.mysdr1
                let OCR = token.myocr + token.myocr1
                let GST = token.mygst + token.mygst1
                let SDR = token.mysdr + token.mysdr1
                let tokenTransactions = await supabase.from('TokenTransactions').select('*').eq('paymentId', token.paymentId).eq('status', 'complete')
                for (const transaction of tokenTransactions.data) {
                    allotment.paidamount = allotment.paidamount + transaction.amount
                    tokenpaidamount += transaction.amount
                    let mode = (allotment.paidamount) < allotment.bookingamt.total ? 'partial' : 'complete'
                    console.log(mode)
                    allotment.paidamt = allotment.paidamt ? allotment.paidamt : { ocr: 0, gst: 0, sdr: 0 };
                    let paidAmt = allotment.paidamt;
                    let myamt = parseInt(transaction.amount);
                    let ocr = 0;
                    let gst = 0;
                    let sdr = 0;
                    if (myamt <= OCR) {
                        OCR = OCR - myamt
                        ocr = myamt;
                        myamt = 0;
                    } else {
                        ocr = OCR;
                        myamt = myamt - OCR;
                        OCR = 0
                    }
                    allotment.paidamt.ocr = (allotment.paidamt ? allotment.paidamt.ocr : 0) + ocr
                    if (myamt <= GST) {
                        GST = GST - myamt
                        gst = myamt;
                        myamt = 0;
                    } else {
                        gst = GST;
                        myamt = myamt - GST;
                        GST = 0
                    }
                    allotment.paidamt.gst = (allotment.paidamt ? allotment.paidamt.gst : 0) + gst
                    if (myamt <= SDR) {
                        SDR = SDR - myamt
                        sdr = myamt;
                        myamt = 0;
                    } else {
                        sdr = SDR;
                        myamt = myamt - SDR;
                        SDR = 0
                    }
                    allotment.paidamt.sdr = (allotment.paidamt ? allotment.paidamt.sdr : 0) + sdr
                    //! unit cost
                    // if (myamt <= allotment.unitcost.sdr - paidAmt.sdr) {
                    //     sdr = myamt > 0 ? sdr + myamt : sdr;
                    //     myamt = 0;
                    // } else {
                    //     myamt = sdr + myamt - (allotment.unitcost.sdr - paidAmt.sdr);
                    //     sdr = allotment.unitcost.sdr - paidAmt.sdr;
                    // }
                    // if (myamt <= allotment.unitcost.bsp - paidAmt.ocr) {
                    //     ocr = myamt > 0 ? ocr + myamt : ocr;
                    //     myamt = 0;
                    // } else {
                    //     myamt = ocr + myamt - (allotment.unitcost.bsp - paidAmt.ocr);
                    //     ocr = allotment.unitcost.bsp - paidAmt.ocr;
                    // }
                    // if (myamt <= allotment.unitcost.gst - paidAmt.gst) {
                    //     gst = myamt > 0 ? gst + myamt : gst;
                    //     myamt = 0;
                    // } else {
                    //     gst = gst + allotment.unitcost.gst - paidAmt.gst;
                    //     myamt = myamt - (allotment.unitcost.gst - paidAmt.gst);
                    // }
                    paidAmt = allotment.paidamt
                    await supabase.from('AllotmentTransactions').insert({
                        amount: parseFloat(transaction.amount),
                        modeOfPayment: 'Token adjustment',
                        transactionType: 'Allotment',
                        allotmentPaymentId: allotment.allotmentpaymentid,
                        unitId: allotment.unitid,
                        leadId: allotment.leadid,
                        status: 'complete',
                        paymentLinkId: transaction.paymentLinkId,
                        inventoryMergeId: allotment.inventorymergeid,
                        payId: transaction.payId,
                        settlementId: transaction.settlementId,
                        ocr: ocr,
                        sdr: sdr,
                        gst: gst,
                        orderId: transaction.orderId
                    })
                    await supabase.from('AllotmentPayment').update({
                        paidAmt: paidAmt,
                        last_updated_at: new Date().getTime(),
                        status: mode === 'partial' ? 'Partial Payment Done' : 'Payment Complete',
                        paidAmount: allotment.paidamount,
                    }).eq('allotmentPaymentId', allotment.allotmentpaymentid)
                    await supabase.from('LeadStatus').update({
                        last_updated_at: new Date().getTime(),
                        status: mode === 'partial' ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete'
                    }).eq('leadId', allotment.leadid)
                    let status = mode === 'partial' ? 'Allotment Partial Payment Done' : 'Allotment Payment Complete'
                    let unitNo = allotment.unitno ? allotment.unitno : `${allotment.unit1no}-${allotment.unit2no}`
                    let projectName = allotment.projectname ? allotment.projectname : allotment.mergedproject
                    let msg = `${status} for unit ${unitNo} of project ${projectName}`
                    await supabase.from('LeadLogs').insert({
                        message: msg,
                        leadStatus: status,
                        leadId: allotment.leadid
                    })
                    if (mode === 'complete') {
                        let inventoryStatus = await supabase.from("InventoryStatus").select("*").eq("status", "Kyc Pending")
                        if (allotment.unitid) {
                            await supabase.from('Inventory').update({ inventoryStatusId: inventoryStatus.data[0].inventoryStatusId }).eq('unitId', allotment.unitid)
                            await supabase.from('InventoryLogs').insert({
                                unitId: allotment.unitid,
                                leadId: allotment.leadid,
                                status: 'Kyc Pending',
                                pricingType: allotment.pricingtype,
                                projectId: allotment.projectid
                            })
                        } else {
                            await supabase.from('Inventory').update({ inventoryStatusId: inventoryStatus.data[0].inventoryStatusId }).eq('unitId', allotment.unit1id)
                            await supabase.from('InventoryLogs').insert({
                                unitId: allotment.unit1id,
                                leadId: allotment.leadid,
                                status: 'Kyc Pending',
                                pricingType: allotment.pricingtype,
                                projectId: allotment.projectid
                            })
                            await supabase.from('Inventory').update({ inventoryStatusId: inventoryStatus.data[0].inventoryStatusId }).eq('unitId', allotment.unit2id)
                            await supabase.from('InventoryLogs').insert({
                                unitId: allotment.unit2id,
                                leadId: allotment.leadid,
                                status: 'Kyc Pending',
                                pricingType: allotment.pricingtype,
                                projectId: allotment.projectid
                            })
                        }
                    }
                }
               await supabase.from('EventTokenLeadRelations').update({ status: 'adjusted' }).eq('paymentId', token.paymentId)
            }
            
            if (
              allotment?.pricingtype === "preselect" &&
              allotment?.preselectconfirmation === "payment pending"
            ) {
              await supabase
                .from("EventTokenLeadRelations")
                .select("paymentId,paidAmount,amount")
                .eq("paymentId", allotment?.paymentid)
                .then(async (preselectResp) => {
                  const adjustPaidAmount = Number(
                    preselectResp?.data[0]?.paidAmount + tokenpaidamount
                  );
                  await supabase
                    .from("EventTokenLeadRelations")
                    .update({ paidAmount: adjustPaidAmount })
                    .eq("paymentId", allotment?.paymentid)
                    .then(async (response) => {
                      if (adjustPaidAmount === preselectResp?.data[0]?.amount) {
                        await supabase
                          .from("AllotmentPayment")
                          .update({
                            preselectConfirmation: "confirmation pending",
                          })
                          .eq("paymentId", allotment?.paymentid);
                      }
                    });
                })
                .catch((err) => {
                  console.error(err);
                });
            }
            dismissLoader()
            setOpenAlert(false)
            handleClose()
            successTost("Token Amount adjusted successfully")
        } else {
            setOpenAlert(false)
        }
    }

    function calculateBucketingValues(token, type) {
        setSelectedTokens((pre) => {
            // for (const m of pre) {
            //     allotment.bookingamt.ocr = allotment.bookingamt.ocr + m.myocr
            //     allotment.bookingamt.gst = allotment.bookingamt.gst + m.mygst
            //     allotment.bookingamt.sdr = allotment.bookingamt.sdr + m.mysdr
            //     allotment.unitcost.ocr = allotment.unitcost.ocr + m.myocr1
            //     allotment.unitcost.gst = allotment.unitcost.gst + m.mygst1
            //     allotment.unitcost.sdr = allotment.unitcost.sdr + m.mysdr1
            // }
            if (type === 'add') {
                pre.push(token);
                if (token.linkedTokenId) {
                    pre.push(token.linkedTokenId)
                }
            } else {
                pre.splice(pre.findIndex((e) => e.paymentId === token.paymentId), 1);
                if (pre.findIndex((e) => e.linkedTokenId === token.paymentId) !== -1) {
                    pre.splice(pre.findIndex((e) => e.linkedTokenId === token.paymentId), 1);
                }
            }
            let currentocr = allotment.paidamt?.ocr ? allotment.paidamt.ocr : 0
            let currentgst = allotment.paidamt?.gst ? allotment.paidamt.gst : 0
            let currentsdr = allotment.paidamt?.sdr ? allotment.paidamt.sdr : 0
            for (const m of pre) {
                let amt = m.paidAmount
                // if (m.linkedTokenId) {
                //     amt = amt + m.linkedTokenId.paidAmount
                // }
                let myocr = 0
                let mygst = 0
                let mysdr = 0
                let myocr1 = 0
                let mygst1 = 0
                let mysdr1 = 0
                if (amt > 0 && allotment.bookingamt.ocr - currentocr > 0) {
                    myocr = amt > (allotment.bookingamt.ocr - currentocr) ? (allotment.bookingamt.ocr - currentocr) : amt;
                    amt = amt - (allotment.bookingamt.ocr - currentocr)
                    // allotment.bookingamt.ocr = allotment.bookingamt.ocr - myocr
                }
                if (amt > 0 && allotment.bookingamt.gst - currentgst > 0) {
                    mygst = amt > (allotment.bookingamt.gst - currentgst) ? (allotment.bookingamt.gst - currentgst) : amt;
                    amt = amt - (allotment.bookingamt.gst - currentgst)
                    // allotment.bookingamt.gst = allotment.bookingamt.gst - mygst
                }
                if (amt > 0 && allotment.bookingamt.sdr - currentsdr > 0) {
                    mysdr = amt > (allotment.bookingamt.sdr - currentsdr) ? (allotment.bookingamt.sdr - currentsdr) : amt;
                    amt = amt - (allotment.bookingamt.sdr - currentsdr)
                    // allotment.bookingamt.sdr = allotment.bookingamt.sdr - mysdr
                }
                if (amt > 0 && allotment.unitcost.sdr - (currentsdr + mysdr) > 0) {
                    let oldsdr = mysdr;
                    mysdr1 = amt > (allotment.unitcost.sdr - (currentsdr)) ? (allotment.unitcost.sdr - (currentsdr)) : mysdr1 + amt;
                    amt = amt - (allotment.unitcost.sdr - (currentsdr))
                    // allotment.unitcost.sdr = allotment.unitcost.sdr - mysdr1
                }
                if (amt > 0 && allotment.unitcost.bsp - (currentocr + myocr) > 0) {
                    let oldocr = myocr
                    myocr1 = amt > (allotment.unitcost.bsp - (currentocr)) ? (allotment.unitcost.bsp - (currentocr)) : myocr1 + amt;
                    amt = amt - (allotment.unitcost.bsp - (currentocr))
                    // allotment.unitcost.ocr = allotment.unitcost.ocr - myocr1
                }
                if (amt > 0 && allotment.unitcost.gst - (currentgst + mygst) > 0) {
                    let oldgst = mygst
                    mygst1 = amt > (allotment.unitcost.gst - (currentgst)) ? (allotment.unitcost.gst - (currentgst)) : mygst1 + amt;
                    amt = amt - (allotment.unitcost.gst - (currentgst))
                    // allotment.unitcost.gst = allotment.unitcost.gst - mygst1
                }
                currentocr = currentocr + myocr + myocr1
                currentgst = currentgst + mygst + mygst1
                currentsdr = currentsdr + mysdr + mysdr1
                m.myocr = myocr
                m.mygst = mygst
                m.mysdr = mysdr
                m.myocr1 = myocr1
                m.mygst1 = mygst1
                m.mysdr1 = mysdr1
            }
            return [...pre]
        })
    }

    return (
        <>
            <Modal
                open={open}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        closeModal();
                    }
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={[
                    {
                        ".MuiBackdrop-root": {
                            background: "rgba(52, 64, 84, 0.7)",
                        },
                    },
                ]}
                disableAutoFocus={true}
            // button
            >
                <Box className={cssClasses.modalWrapper}>
                    <div className={cssClasses.wrapperHeader}>
                        <span
                            className={classes.closeIcon}
                            onClick={closeModal}
                            tabIndex={0}
                        >
                            <Close width={"1.2rem"} height={"1.2rem"} />
                        </span>
                        <div>Adjust Token</div>
                    </div>
                    {allotment &&
                        <div className={cssClasses.wrapperContent} >
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '100%',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div className={cssClasses.tokenNumWrap}>
                                    <p>{allotment.leadname}</p>
                                </div>
                                <div className={cssClasses.allotmentPaymentId}>
                                    <p>{allotment.allotmentpaymentid}</p>
                                </div>
                            </div>
                            <div className={cssClasses.cardHeader}>
                                <div className={cssClasses.tokenNumWrap}>
                                    {allotment?.unitno && (
                                        <span>
                                            {/* {allotment?.wingname} - {allotment?.unitno}{" "} */}
                                            {allotment?.displaywingname ? allotment?.displaywingname : allotment?.wingname} - {allotment?.unitno}{" "}
                                        </span>
                                    )}
                                    {allotment?.inventorymergeid && (
                                        <span>
                                            {allotment?.mergedwing} - {allotment?.unit1no}
                                            {"-"}
                                            {allotment?.unit2no}
                                        </span>
                                    )}
                                    <span>|</span>
                                    {allotment?.projectname && <span>{allotment?.projectname}</span>}
                                    {allotment?.inventorymergeid && (
                                        <span>{allotment?.mergedproject}</span>
                                    )}
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        gap: '2rem'
                                    }}
                                >
                                    <div className={cssClasses.tokenStatus}>
                                        {allotment.status === "On Hold" && (
                                            <LeadStatusChip
                                                label={allotment.status}
                                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                style={{
                                                    color: "rgb(89, 37, 220)",
                                                    backgroundColor: "rgb(244, 243, 255)",
                                                }}
                                            ></LeadStatusChip>
                                        )}
                                        {allotment.status === "Released" && (
                                            <LeadStatusChip
                                                label={allotment.status}
                                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                style={{
                                                    color: "rgb(180, 35, 24)",
                                                    backgroundColor: "rgb(254, 243, 242)",
                                                }}
                                            ></LeadStatusChip>
                                        )}
                                        {allotment.status.toLowerCase().includes("cancel") && (
                                            <LeadStatusChip
                                                label={allotment.status}
                                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                style={{
                                                    color: "rgb(180, 35, 24)",
                                                    backgroundColor: "rgb(254, 243, 242)",
                                                }}
                                            ></LeadStatusChip>
                                        )}
                                        {allotment.status === "Partial Payment Done" && (
                                            <LeadStatusChip
                                                label={allotment.status}
                                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                                            ></LeadStatusChip>
                                        )}
                                        {allotment.status === "Payment Complete" && (
                                            <LeadStatusChip
                                                label={allotment.status}
                                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                                            ></LeadStatusChip>
                                        )}
                                        {allotment.status === "Preselected" && (
                                            <LeadStatusChip
                                                label={allotment.status}
                                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                                            ></LeadStatusChip>
                                        )}
                                        {allotment.status === "Payment Pending" && (
                                            <LeadStatusChip
                                                label={allotment.status}
                                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                                            ></LeadStatusChip>
                                        )}
                                        {allotment.status === "Payment Complete" &&
                                            allotment.paidAmount >=
                                            allotment?.unitId?.projectId?.bookingAmt &&
                                            allotment.paidAmount -
                                            allotment?.unitId?.projectId?.bookingAmt <
                                            allotment.SDR && (
                                                <LeadStatusChip
                                                    label={"SDR Payment Pending"}
                                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                                                ></LeadStatusChip>
                                            )}
                                    </div>
                                    <div className={cssClasses.tokenStatus}>
                                        {allotment.status.includes("Payment") &&
                                            !allotment.kycformfilled && (
                                                <LeadStatusChip
                                                    label={"Kyc pending"}
                                                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                    style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                                                ></LeadStatusChip>
                                            )}
                                        {allotment.kycformfilled && (
                                            <LeadStatusChip
                                                label={"Kyc complete"}
                                                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                                style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                                            ></LeadStatusChip>
                                        )}
                                    </div>

                                </div>
                            </div>
                            {tokens.length > 0 &&
                                <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'space-between' }}>
                                    <div>
                                        <div className={cssClasses.amountsWrapper} style={{ marginBottom: '1rem' }}>
                                            <p>Before Adjustment</p>
                                            <p>Breakdown Of Pending Booking</p>
                                        </div>
                                        <div className={cssClasses.amountsWrapper}>
                                            {/* <p>Pending Amount : ₹{numberWithCommas((allotment.bookingamt.total - allotment.paidamount) - selectedTokens.map((m) => m.paidAmount).reduce(add, 0))}</p> */}
                                            <p>Total : ₹{numberWithCommas(allotment.bookingamt.total > allotment.paidamount ? allotment.bookingamt.total - allotment.paidamount : 0)}</p>
                                            {/* <p>Paid Amount : ₹{numberWithCommas(allotment.paidamount)}</p> */}
                                            <p>ocr : ₹{numberWithCommas(allotment.bookingamt.ocr - (allotment.paidamt ? allotment.paidamt.ocr : 0) > 0 ? allotment.bookingamt.ocr - (allotment.paidamt ? allotment.paidamt.ocr : 0) : 0)}</p>
                                            <p>gst : ₹{numberWithCommas(allotment.bookingamt.gst - (allotment.paidamt ? allotment.paidamt.gst : 0) > 0 ? allotment.bookingamt.gst - (allotment.paidamt ? allotment.paidamt.gst : 0) : 0)}</p>
                                            <p>sdr : ₹{numberWithCommas(allotment.bookingamt.sdr - (allotment.paidamt ? allotment.paidamt.sdr : 0) > 0 ? allotment.bookingamt.sdr - (allotment.paidamt ? allotment.paidamt.sdr : 0) : 0)}</p>
                                            {/* <p>ocr : ₹{numberWithCommas(allotment.bookingamt.ocr > (allotment.paidamt ? allotment.paidamt.ocr : 0) ? allotment.bookingamt.ocr - (allotment.paidamt ? allotment.paidamt.ocr : 0) + selectedTokens.map((m) => m.myocr).reduce(add, 0) : 0 + selectedTokens.map((m) => m.myocr).reduce(add, 0))}</p>
                                            <p>gst : ₹{numberWithCommas(allotment.bookingamt.gst > (allotment.paidamt ? allotment.paidamt.gst : 0) ? allotment.bookingamt.gst - (allotment.paidamt ? allotment.paidamt.gst : 0) + selectedTokens.map((m) => m.mygst).reduce(add, 0) : 0 + selectedTokens.map((m) => m.mygst).reduce(add, 0))}</p>
                                            <p>sdr : ₹{numberWithCommas(allotment.bookingamt.sdr > (allotment.paidamt ? allotment.paidamt.sdr : 0) ? allotment.bookingamt.sdr - (allotment.paidamt ? allotment.paidamt.sdr : 0) + selectedTokens.map((m) => m.mysdr).reduce(add, 0) : 0 + selectedTokens.map((m) => m.mysdr).reduce(add, 0))}</p> */}
                                            {/* <p>ocr : ₹{numberWithCommas((allotment.bookingamt ? allotment.bookingamt.ocr : 0) + selectedTokens.map((m) => m.myocr).reduce(add, 0))}</p>
                                            <p>ocr : ₹{numberWithCommas((allotment.bookingamt ? allotment.bookingamt.gst : 0) + selectedTokens.map((m) => m.mygst).reduce(add, 0))}</p>
                                            <p>ocr : ₹{numberWithCommas((allotment.bookingamt ? allotment.bookingamt.sdr : 0) + selectedTokens.map((m) => m.mysdr).reduce(add, 0))}</p> */}
                                        </div>
                                    </div>
                                    {/* <div> */}
                                    <div>
                                        <div className={cssClasses.amountsWrapper} style={{ marginBottom: '1rem' }}>
                                            <p>After Adjustment</p>
                                            <p>Breakdown Of Pending Booking</p>
                                        </div>
                                        <div className={cssClasses.amountsWrapper}>
                                            {/* <p>Pending Amount : ₹{numberWithCommas((allotment.bookingamt.total - allotment.paidamount) - selectedTokens.map((m) => m.paidAmount).reduce(add, 0))}</p> */}
                                            <p>Total : ₹{numberWithCommas(selectedTokens.map((m) => m.myocr + m.mygst + m.mysdr).reduce(add, 0))}</p>
                                            {/* <p>Paid Amount : ₹{numberWithCommas(allotment.paidamount)}</p> */}
                                            <p>ocr : ₹{numberWithCommas(selectedTokens.map((m) => m.myocr).reduce(add, 0))}</p>
                                            <p>gst : ₹{numberWithCommas(selectedTokens.map((m) => m.mygst).reduce(add, 0))}</p>
                                            <p>sdr : ₹{numberWithCommas(selectedTokens.map((m) => m.mysdr).reduce(add, 0))}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <div className={cssClasses.amountsWrapper} style={{ marginBottom: '1rem' }}>
                                            <p>After Adjustment</p>
                                            <p>Breakdown Of Excess Amount</p>
                                        </div>
                                        <div className={cssClasses.amountsWrapper}>
                                            {/* <p>Pending Amount : ₹{numberWithCommas((allotment.bookingamt.total - allotment.paidamount) - selectedTokens.map((m) => m.paidAmount).reduce(add, 0))}</p> */}
                                            <p>Total : ₹{numberWithCommas(selectedTokens.map((m) => m.myocr1 + m.mygst1 + m.mysdr1).reduce(add, 0))}</p>
                                            {/* <p>Paid Amount : ₹{numberWithCommas(allotment.paidamount)}</p> */}
                                            <p>ocr : ₹{numberWithCommas(selectedTokens.map((m) => m.myocr1).reduce(add, 0))}</p>
                                            <p>gst : ₹{numberWithCommas(selectedTokens.map((m) => m.mygst1).reduce(add, 0))}</p>
                                            <p>sdr : ₹{numberWithCommas(selectedTokens.map((m) => m.mysdr1).reduce(add, 0))}</p>
                                        </div>
                                    </div>
                                    {/* </div> */}
                                </div>
                            }
                            {/* <div className={cssClasses.amountsWrapper}> */}
                            {/* <p>Paid Amount : ₹{numberWithCommas(allotment.paidamount)}</p> */}
                            {/* </div> */}
                            {flag &&
                                <>
                                    {tokens.length > 0 ?
                                        <>
                                            <div className={cssClasses.tokensDiv} style={{
                                                overflowY: 'auto',
                                                padding: '1rem'
                                            }}>
                                                <div>
                                                    <p style={{ fontSize: "1.8rem", fontWeight: '600' }}>Token List</p>
                                                </div>
                                                {tokens.map((m => (
                                                    <Card className={cssClasses.tokenCard}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'flex-start',
                                                            flexDirection: 'row',
                                                            flexWrap: 'wrap',
                                                            gap: '2rem'
                                                        }}>
                                                            <Checkbox
                                                                sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                                                                checked={selectedTokens.filter((e) => { return e.paymentId === m.paymentId }).length > 0 ? true : false}
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        let currentAmount = selectedTokens.reduce((partialSum, a) => partialSum + a.paidAmount, 0)
                                                                        let amountToBePaid = allotment.unitcost.total - allotment.paidamount
                                                                        console.log("currentAmount + m.paidAmount", currentAmount + m.paidAmount)
                                                                        console.log("amountToBePaid", amountToBePaid)
                                                                        if (allotment.pricingtype === "preselect") {
                                                                            calculateBucketingValues(m, 'add')
                                                                        } else {
                                                                            if ((currentAmount + m.paidAmount) > amountToBePaid) {
                                                                                errorTost("Cannot select token as amount is exceeding unit cost")
                                                                            } else {
                                                                                calculateBucketingValues(m, 'add')
                                                                            }
                                                                        }

                                                                    } else {
                                                                        // allotment.bookingamt.ocr = allotment.bookingamt.ocr + m.myocr
                                                                        // allotment.bookingamt.gst = allotment.bookingamt.gst + m.mygst
                                                                        // allotment.bookingamt.sdr = allotment.bookingamt.sdr + m.mysdr
                                                                        // allotment.unitcost.ocr = allotment.unitcost.ocr + m.myocr1
                                                                        // allotment.unitcost.gst = allotment.unitcost.gst + m.mygst1
                                                                        // allotment.unitcost.sdr = allotment.unitcost.sdr + m.mysdr1
                                                                        calculateBucketingValues(m, 'delete')
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        <div >
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'flex-start',
                                                                flexDirection: 'row',
                                                                flexWrap: 'wrap',
                                                                gap: '2rem'
                                                            }}>
                                                                <p>{m.eventTokenId.tokenId.name}</p>
                                                                <p>{m.paidAmount}</p>
                                                                <p>VJ{m.tokenNumber}</p>
                                                                <p>{m.eventId.title}</p>
                                                            </div>
                                                            {m.linkedTokenId &&
                                                                <div style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'flex-start',
                                                                    flexDirection: 'row',
                                                                    flexWrap: 'wrap',
                                                                    gap: '2rem'
                                                                }}>
                                                                    <p>{m.linkedTokenId.eventTokenId.tokenId.name}</p>
                                                                    <p>{m.linkedTokenId.paidAmount}</p>
                                                                    <p>{m.linkedTokenId.tokenNumber}</p>
                                                                    <p>{m.linkedTokenId.eventId.title}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </Card>
                                                )))
                                                }
                                            </div>
                                        </>
                                        :
                                        <div>
                                            <p style={{ fontSize: "1.8rem", fontWeight: '600' }}> No Tokens Available</p>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    }
                    <div className={cssClasses.wrapperFooter}>
                        <div>
                            <Button
                                style={{
                                    color: "#344054",
                                    backgroundColor: "#ffffff",
                                    fontSize: "1.6rem",
                                    lineHeight: "2.4rem",
                                }}
                                btnName={"Cancel"}
                                clicked={() => {
                                    for (const ele of selectedTokens) {
                                        allotment.bookingamt.ocr = allotment.bookingamt.ocr + ele.myocr
                                        allotment.bookingamt.gst = allotment.bookingamt.gst + ele.mygst
                                        allotment.bookingamt.sdr = allotment.bookingamt.sdr + ele.mysdr
                                        allotment.unitcost.ocr = allotment.unitcost.ocr + ele.myocr1
                                        allotment.unitcost.gst = allotment.unitcost.gst + ele.mygst1
                                        allotment.unitcost.sdr = allotment.unitcost.sdr + ele.mysdr1
                                    }
                                    handleClose()
                                }}
                            />
                        </div>
                        {tokens.length > 0 &&
                            <div>
                                <Button
                                    style={{
                                        color: "#ffffff",
                                        backgroundColor: "#155EEF",
                                        fontSize: "1.6rem",
                                        lineHeight: "2.4rem",
                                    }}
                                    btnName={"Save"}
                                    clicked={submit}
                                />
                            </div>
                        }
                    </div>
                </Box>
            </Modal >
            {openAlert &&
                <ConfirmationAlert confirm={(e) => { ModalResp(e) }} buttonTitle={'Cancel'} returnRespButton={'Confirm'} close={() => setOpenAlert(false)} title={'Warning'} subTitle={'Are you sure! Adjusted token amount cannot be reverted, Please confirm to continue'} open={openAlert} />
            }
        </>
    )
}
